var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCrowdvotingFoerdersummenVisualisierungInlineRgb = function SvgCrowdvotingFoerdersummenVisualisierungInlineRgb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 373.3,
    height: 132.4,
    viewBox: "0 0 373.3 132.4",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M120.9,16.5C120.9,5.7,100,0,79.3,0s-41.6,5.7-41.6,16.5v25.8c1.6-.2,3.2-.2,4.8-.2.9,0,1.7,0,2.6.1-.4-.5-.6-1-.7-1.4v-.1c0-.6.4-1.2,1.2-2,1.4.7,2.9,1.4,4.6,2,4.2,1.5,9.2,2.7,14.5,3.4,4.7.6,9.6,1,14.6,1s9.9-.3,14.6-1c5.3-.7,10.3-1.9,14.5-3.4,1.7-.6,3.2-1.3,4.6-2,.8.7,1.2,1.4,1.2,2s-.4,1.3-1.2,2c-1.4,1.3-4,2.8-7.7,4-3,1.1-6.9,2-11.4,2.7-4.2.6-9.1,1-14.6,1-3.9,0-7.4-.2-10.6-.5,3.2,2.1,6.1,4.5,8.6,7.3h2c4.9,0,9.9-.3,14.6-1,5.3-.7,10.3-1.9,14.5-3.4,1.7-.6,3.2-1.3,4.6-2,.8.7,1.2,1.4,1.2,2s-.4,1.3-1.2,2c-1.4,1.3-4,2.8-7.7,4-3,1.1-6.9,2-11.4,2.7-3.6.5-7.7.9-12.2,1,1.5,2.1,2.8,4.3,3.9,6.6,2.9-.2,5.7-.4,8.4-.8,5.3-.7,10.3-1.9,14.5-3.4,1.7-.6,3.2-1.3,4.6-2,.8.7,1.2,1.4,1.2,2s-.4,1.3-1.2,2c-1.4,1.3-4,2.8-7.7,4-3,1.1-6.9,2-11.4,2.7-1.9.3-4,.5-6.3.7.3,1,.6,1.9.9,2.9.3,1.2.6,2.4.8,3.7,1.5-.1,3.1-.3,4.6-.5,4.6-.6,8.8-1.6,12.6-2.8.6-.2,1.2-.4,1.8-.6,1.7-.6,3.2-1.3,4.6-2,.8.7,1.2,1.4,1.2,2s-.4,1.3-1.2,2c-1.2,1.1-3.4,2.4-6.4,3.6-.4.1-.8.3-1.2.4-.9.3-1.9.6-3,.9-3.4.9-7.5,1.7-12.3,2.2.1,1.1.1,2.3.1,3.4s-.1,2.2-.1,3.4c8.9-.9,17.2-2.8,22.9-5.9.8.7,1.2,1.4,1.2,2,0,2.8-8.7,7.7-24.8,9.3-.4,2.4-1.1,4.7-1.8,6.9,17.6-1.3,33.4-6.8,33.4-16.2V16.7h0c-.2,0-.2-.1-.1-.2h0ZM112.9,30.7c-1.4,1.3-4,2.8-7.7,4-3.1,1.1-6.9,2-11.4,2.7-4.2.6-9.1,1-14.5,1s-10.3-.4-14.5-1c-4.5-.7-8.4-1.6-11.4-2.7-3.7-1.3-6.3-2.7-7.7-4-.8-.7-1.2-1.4-1.2-2v-.1c0-.6.4-1.2,1.2-1.9,1.4.7,2.9,1.4,4.6,2,4.2,1.5,9.2,2.7,14.5,3.4,4.7.6,9.6,1,14.6,1s9.9-.3,14.6-1c5.3-.7,10.3-1.9,14.5-3.4,1.7-.6,3.2-1.3,4.6-2,.8.7,1.2,1.4,1.2,2s-.6,1.2-1.4,2ZM112.9,18.5c-1.4,1.3-3.9,2.8-7.7,4-3.1,1.1-6.9,2-11.4,2.7-4.2.6-9.1,1-14.6,1s-10.3-.4-14.6-1c-4.5-.7-8.3-1.6-11.4-2.7-3.7-1.3-6.3-2.7-7.7-4-.8-.7-1.2-1.4-1.2-2,0-3.3,12.3-9.7,34.8-9.7s34.8,6.4,34.8,9.7c.2.6-.2,1.3-1,2h0Z",
    style: {
      fill: "#a5cf4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6,132.4C19.1,132.4,0,113.3,0,89.8s19.1-42.6,42.6-42.6,42.6,19.1,42.6,42.6-19.1,42.6-42.6,42.6ZM42.6,53.9c-19.8,0-35.9,16.1-35.9,35.9s16.1,35.9,35.9,35.9,35.9-16.1,35.9-35.9-16.2-35.9-35.9-35.9Z",
    style: {
      fill: "#a5cf4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6,100.8l-.6.7c-1.4,1.6-3,2.9-4.8,3.8s-3.9,1.3-6.4,1.3c-3.1,0-5.8-.7-8-2.1s-3.8-3.2-5.1-5.6h14.2l2.2-6.7h-18.2c-.1-.8-.1-1.6-.1-2.3,0-.8,0-1.6.1-2.5h18.7l2.2-6.7h-19c1.2-2.3,2.8-4.2,4.9-5.6,2.2-1.4,4.8-2.1,7.8-2.1,2.4,0,4.6.4,6.4,1.3s3.4,2.1,4.8,3.7l.6.8,5.6-5.6-.6-.6c-2.2-2.2-4.6-3.9-7.2-5.2-2.6-1.3-5.9-1.9-9.3-1.9s-6.6.5-9.5,1.7-5.3,3-7.3,5.2-3.6,4.8-4.7,7.8c0,.1-.1.3-.1.4h-5.9v6.7h4.5c-.1.9-.1,1.7-.1,2.5s0,1.5.1,2.3h-4.5v6.7h5.9c0,.1.1.3.1.4,1.1,3,2.7,5.6,4.7,7.8s4.5,4,7.3,5.2,5.9,1.9,9.4,1.9h0c3.5,0,6.7-.7,9.5-1.9,2.7-1.3,5.2-3.1,7.4-5.3l.6-.6s-5.6-5.5-5.6-5.5Z",
    style: {
      fill: "#a5cf4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,18.8v2.8c0,2.2-.1,3.8-3.1,5.7l-5.5,3.4c-.9.5-1.3.9-1.3,1.8v.5h10c.1,0,.2.1.2.2v3.9c0,.2-.1.2-.2.2h-16c-.6,0-.8-.3-.8-.8v-2.8c0-2.6,1-3.7,4-5.6l6.6-4.4c1-.7,1.3-1.5,1.3-2.8v-1c0-2-1.4-2.4-4.4-2.4h-6.1c-.2,0-.4-.1-.4-.3v-2.7c0-.4.2-.6.6-.7,2-.4,3.3-.5,6.4-.5,4.6-.2,8.7.6,8.7,5.5h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.1,25.4c0,9.4-1.8,12.1-9.2,12.1s-9.2-2.7-9.2-12.1,1.8-12.2,9.2-12.2,9.3,2.8,9.2,12.2h0ZM167.7,25.4c0,6.1.8,7.9,4.3,7.9s4.3-1.8,4.3-7.9-.8-7.9-4.3-7.9c-3.5-.1-4.3,1.7-4.3,7.9Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.5,25.4c0,9.4-1.8,12.1-9.2,12.1s-9.2-2.7-9.2-12.1,1.8-12.2,9.2-12.2,9.2,2.8,9.2,12.2h0ZM189.1,25.4c0,6.1.8,7.9,4.3,7.9s4.3-1.8,4.3-7.9-.8-7.9-4.3-7.9c-3.5-.1-4.3,1.7-4.3,7.9Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,13.8c.4.1.5.3.5.5v2.5c0,.4-.2.5-.6.5h-7.3c-1.9,0-2.8.6-2.8,2v.4c0,1,.4,1.8,1.9,2.3l5.8,2.3c3,1.1,4.3,2.6,4.3,6.3v.8c0,4.6-3.5,5.9-9,5.9-2.3,0-4.8-.2-7.6-.6-.4-.1-.5-.3-.5-.7v-2.4c0-.4.2-.5.6-.5h8.8c1.9,0,2.8-.5,2.8-1.9v-.4c0-1.4-.6-2-2.2-2.6l-6.1-2.3c-2.6-.9-3.7-2.7-3.7-6.4v-.7c0-4.6,3.2-5.9,8.7-5.9,2.6.2,4,.5,6.4.9h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.5,15.1c.3-.1.5.1.5.5v4.4h2.8c.3,0,.5.2.5.5v2.5c0,.3-.2.4-.5.4h-2.8v8.5c0,1.4.4,1.6,1.9,1.6h1.3c.4,0,.5.1.5.4v2.6c0,.4-.1.5-.5.6-1,.2-2,.3-2.6.3-2.7,0-5.1-.1-5.1-4v-10h-1.9c-.3,0-.5-.2-.5-.4v-2.5c0-.3.1-.5.5-.5h1.9v-3.4c0-.3.1-.4.4-.5l3.6-1h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.1,15.1c0,1.6-.9,2.5-2.7,2.5s-2.7-.9-2.7-2.5.9-2.5,2.7-2.5,2.7.9,2.7,2.5ZM247.3,19.9c.3,0,.4.2.4.5v16.4c0,.3-.1.5-.4.5h-3.7c-.3,0-.4-.2-.4-.5v-16.3c0-.3.1-.5.4-.5h3.7v-.1Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.3,26.4v10.4c0,.3-.1.5-.5.5h-3.7c-.3,0-.5-.2-.5-.5v-8.5c0-4.4-.5-4.7-2.9-4.7-.8,0-1.8.1-2.5.2.3.8.4,1.9.4,3.3v9.6c0,.3-.1.5-.4.5h-3.7c-.3,0-.4-.2-.4-.5v-9.5c0-3.4-.6-3.5-3-3.5h-2.1v13c0,.3-.1.5-.4.5h-3.7c-.3,0-.4-.2-.4-.5v-15.9c0-.3.1-.4.4-.5,1.7-.4,4.4-.5,5.9-.5,2.4,0,4.4.4,5.5,1,1.7-.6,3.9-1,5.4-1,4.8-.1,6.6,1.3,6.6,6.6h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.9,26.4v10.4c0,.3-.1.5-.5.5h-3.7c-.3,0-.5-.2-.5-.5v-8.5c0-4.4-.5-4.7-2.9-4.7-.8,0-1.8.1-2.5.2.3.8.4,1.9.4,3.3v9.6c0,.3-.1.5-.4.5h-3.7c-.3,0-.4-.2-.4-.5v-9.5c0-3.4-.6-3.5-3-3.5h-2.1v13c0,.3-.1.5-.5.5h-3.7c-.3,0-.5-.2-.5-.5v-15.9c0-.3.1-.4.4-.5,1.7-.4,4.4-.5,5.9-.5,2.4,0,4.4.4,5.5,1,1.7-.6,3.8-1,5.4-1,4.9-.1,6.7,1.3,6.8,6.6h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.4,28.4v.9c0,.6-.2.8-1,.8h-9.7c.1,2.8.8,3.3,3.5,3.3h5.5c.3,0,.5.2.5.4v2.6c0,.3-.1.4-.4.5-1.7.3-3.9.4-5.9.4-6.3,0-7.8-1.8-7.8-8.9s1.6-8.9,7.8-8.9,7.5,2,7.5,8.9h0ZM310.6,27.2h6.2c0-2.7-.7-3.4-3-3.4s-3.2.6-3.2,3.4Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,27.2v9.6c0,.3-.2.5-.5.5h-3.7c-.3,0-.5-.2-.5-.5v-8.5c0-4.4-.5-4.7-3.3-4.7h-2.8v13c0,.3-.1.5-.4.5h-3.7c-.3,0-.5-.2-.5-.5v-16c0-.4.1-.4.5-.5,2.1-.5,5.1-.5,7.4-.5,5.9.2,7.5,1.3,7.5,7.6h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,21.1c.4,0,.5.2.5.5v4c0,.4-.2.5-.5.5h-19.4c-.4,0-.5-.2-.5-.5v-4c0-.4.2-.5.5-.5h19.4ZM372.8,31c.4,0,.5.2.5.5v4c0,.4-.2.5-.5.5h-19.4c-.4,0-.5-.2-.5-.5v-4c0-.4.2-.5.5-.5h19.4Z",
    style: {
      fill: "#a5cf4c",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.3,60.5v4.9c0,3.7-.3,6.5-5.4,9.8l-9.6,5.9c-1.6.9-2.2,1.6-2.2,3v.9h17.3c.4,0,.4.1.4.3v6.7c0,.3-.1.3-.4.3h-27.4c-1.1,0-1.5-.6-1.5-1.5v-4.8c0-4.5,1.9-6.4,6.8-9.7l11.4-7.5c1.8-1.1,2.1-2.6,2.1-4.9v-1.8c0-3.3-2.3-4.2-7.5-4.2h-10.3c-.4,0-.6-.2-.6-.6v-4.6c0-.7.3-1,1-1.1,3.4-.6,5.7-.9,10.8-.9,8,.1,15.1,1.5,15.1,9.8h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,51.1c.5,0,.8.3.8.8v5.7c0,.5-.3.8-.8.8h-18.5l-.7,8.7c1.6-.2,4.2-.3,5.4-.3,9.8,0,15.2,2,15.3,11.1v4c-.1,9-5.6,11-16.3,11-4.2,0-8.5-.3-11.1-.7-.8-.1-1.3-.4-1.3-1.3v-4.7c0-.5.3-.7.8-.7h11c7,0,8.3-1.3,8.3-5.4v-.4c-.1-4.1-1.5-5.5-8.3-5.5h-10.3c-1,0-1.5-.3-1.5-1v-5.1l1.3-16.1c.1-.5.3-.8.8-.8l25.1-.1h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,71.9c0,16.2-3.1,20.9-15.9,20.9s-15.9-4.7-15.9-20.9,3.1-21.1,15.9-21.1,15.9,4.8,15.9,21.1ZM218.9,71.9c0,10.4,1.5,13.6,7.4,13.6s7.4-3.1,7.4-13.6-1.4-13.8-7.4-13.8-7.4,3.2-7.4,13.8Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.1,51.1c.5,0,.8.3.8.8v5.7c0,.5-.3.8-.8.8h-19.2v10.1h17.5c.5,0,.8.3.8.8v5.4c0,.5-.3.8-.8.8h-17.5v9.6h19.2c.5,0,.8.3.8.8v5.7c0,.5-.3.8-.8.8h-26.8c-.5,0-.8-.3-.8-.8v-39.6c0-.5.3-.8.8-.8,0-.1,26.8-.1,26.8-.1Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.1,62.5c.5,0,.7.3.7.8v27.5c0,.7-.2.8-.7.9-3.7.7-8.9.9-12.8.9-10.2,0-12.8-1.9-12.8-12.8v-16.5c0-.5.3-.8.8-.8h6.3c.5,0,.7.3.7.8v14.5c0,7.7.8,8,5.7,8h4.8v-22.5c0-.5.3-.8.8-.8h6.5Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8,62.9c.6.2.8.4.8,1v4.4c0,.5-.3.8-.9.8h-5c-2.8,0-3.8.4-3.8,2.7v19.7c0,.6-.3.8-.8.8h-6.4c-.5,0-.8-.3-.8-.8v-21.7c0-6.7,4.8-7.5,9.7-7.5,1.6,0,5.4.1,7.2.6h0Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.3,77.5c0,12.2-2.5,15.2-13.7,15.2s-13.7-3-13.7-15.2,2.6-15.2,13.7-15.2,13.7,3,13.7,15.2ZM354,77.5c0,6.7.8,8.3,5.6,8.3s5.7-1.7,5.7-8.3-.8-8.3-5.7-8.3-5.6,1.5-5.6,8.3Z",
    style: {
      fill: "#0063af",
      strokeWidth: 0
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCrowdvotingFoerdersummenVisualisierungInlineRgb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crowdvoting-foerdersummen-visualisierung-inline-rgb.b3a0da40ee5cb5052088235a78530c40.svg";